import { FaBars } from 'react-icons/fa';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  LogoImage,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLang,
  NavLink,
  NavLinkR,
  NavBtn,
  LangItem,
  LangImg,
  LogoBlock,
  InnioLink,
  InnioImage,
} from './NavbarElements';
import en from '../../img/lang/en.png';
import md from '../../img/lang/md.png';
import ru from '../../img/lang/ru.png';

import vipropat from '../../img/vipropat.png';
import innio from '../../img/jenbacherinnio1.png';

import { MainPageText } from '../Library/LibraryMainPage';
import { useLanguage } from '../../hooks';

const Navbar = ({ toggle }) => {
  const { lang, setLanguage } = useLanguage();

  const scrollWithOffset = (el, offset) => {
    const elementPosition = el.offsetTop - offset;
    window.scroll({
      top: elementPosition,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    window.location.reload();
  };

  return (
    <Nav>
      <NavbarContainer>
        <LogoBlock>
          <NavLogo to="/" scroll={(el) => scrollWithOffset(el, 100)}>
            <LogoImage src={vipropat} />
          </NavLogo>
        </LogoBlock>

        <NavMenu>
          <NavItem>
            <NavLink to="/#about" scroll={(el) => scrollWithOffset(el, 100)}>
              {MainPageText[lang].about}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/#product" scroll={(el) => scrollWithOffset(el, 100)}>
              {MainPageText[lang].equipment}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/#project" scroll={(el) => scrollWithOffset(el, 100)}>
              {MainPageText[lang].projects}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/#articles" scroll={(el) => scrollWithOffset(el, 100)}>
              {MainPageText[lang].articles}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="/#contact" scroll={(el) => scrollWithOffset(el, 100)}>
              {MainPageText[lang].contacts}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLinkR to="/vacancy">{MainPageText[lang].vacancy}</NavLinkR>
          </NavItem>
        </NavMenu>

        <NavBtn>
          <NavLang>
            <LangItem onClick={() => handleLanguageChange('en')}>
              <LangImg src={en} className={lang === 'en' ? null : 'hideLang'} />
            </LangItem>

            <LangItem onClick={() => handleLanguageChange('md')}>
              <LangImg src={md} className={lang === 'md' ? null : 'hideLang'} />
            </LangItem>

            <LangItem onClick={() => handleLanguageChange('ru')}>
              <LangImg src={ru} className={lang === 'ru' ? null : 'hideLang'} />
            </LangItem>
          </NavLang>
        </NavBtn>
        <LogoBlock className="logo_innio">
          <InnioLink href="https://www.innio.com/">
            <InnioImage src={innio} />
          </InnioLink>
        </LogoBlock>
        <MobileIcon type="button" onClick={toggle} aria-label="Open navigation menu">
          <FaBars />
        </MobileIcon>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
